import Vue from 'vue'
import Router from 'vue-router'
//import store from '@/store'
// mixen routers
import ErrorsRoutes from '@/router/modules/errors'
import HomeRoutes from '@/router/modules/home'
import MenuRoutes from '@/router/modules/menu'
import FaqsRoutes from '@/router/modules/faqs'
import PagesRoutes from '@/router/modules/pages'
import PaymentRoutes from '@/router/modules/payments'
import AppLayout from "@/views/layouts/app.vue"
import PaymentLayout from "@/views/layouts/payment.vue"
import WarningsRoutes from "@/router/modules/warnings";

const routes = [
    {
        path: "/",
        component: PaymentLayout,
        children: PaymentRoutes,
    },
    {
        path: "/",
        component: PaymentLayout,
        children: WarningsRoutes,
    },
    {
        path: "/",
        component: AppLayout,
        children: [].concat(
            HomeRoutes,
            MenuRoutes,
            FaqsRoutes,
            PagesRoutes,
            ErrorsRoutes,
        )
    },
];

Vue.use(Router)
export default new Router({
    mode: 'history',
    base: '/',
    fallback: true,
    routes: routes,
    scrollBehavior() {
        if(document.getElementById('app')) {
            document.getElementById('app').scrollIntoView({ behavior: 'smooth'});
        }
    }
})

